// extracted by mini-css-extract-plugin
module.exports = {"crmCarousel":"_3UPvquw","slickLoading":"_2WagVlp","slickInitialized":"_1dgqHS6","slickVertical":"_2VLXLgi"};